import React, { useState, useEffect, useRef } from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';

import AppHeader from './app/header/AppHeader';
import AppBody from './app/body/AppBody';
import { AppFooter } from './app/footer/AppFooter';
import AgreementsPage from './app/agreements/AgreementsPage';
import { SubscriptionCancelPage, SubscriptionSuccessPage } from './app/agreements/PaymentStep';

const HomePage = () => {
  const [isMobile, setIsMobile] = useState(false);
  const scrollToSection = useRef(null);

  useEffect(() => {
    const checkDevice = () => {
      setIsMobile(window.innerWidth < 1024);
    };

    checkDevice();
    window.addEventListener('resize', checkDevice);

    return () => {
      window.removeEventListener('resize', checkDevice);
    };
  }, []);

  return (
    <div>
      <AppHeader scrollToSection={scrollToSection} isMobile={isMobile} />
      <AppBody scrollToSection={scrollToSection} isMobile={isMobile} />
      <AppFooter scrollToSection={scrollToSection} isMobile={isMobile} />
    </div>
  );
};

const App = () => {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/agreements" element={<AgreementsPage />} />
        <Route path="/subscription-success" element={<SubscriptionSuccessPage />} />
        <Route path="/subscription-cancel" element={<SubscriptionCancelPage />} />
      </Routes>
    </BrowserRouter>
  );
};

export default App;